import { BasicTheme } from '@tencent/exeditor3-theme-basic';
let mockUploadWarned = false;
export const defaultConfig = {
    initialContent: '',
    placeholder: '请输入内容',
    plugins: [],
    textblockAttrsTarget: ['paragraph', 'heading'],
    theme: new BasicTheme(),
    toolbar: {
        static: 'clearFormat paintFormat | heading headingNumbering fontFamily fontSize bold italic underline strikethrough superScript subScript color backgroundColor link quote bulletList orderList hr codeBlock emoji picture video audio table textAlign textIndent fold(marginTop marginBottom marginSide lineSpace wordSpace paragraphCheck) | undo redo',
        popover: '',
    },
    upload: (file) => {
        if (!mockUploadWarned) {
            console.warn("You are using exeditor3 preset-editor's built-in uploader, which is for demo purpose only. This tip will only be showed once.");
            mockUploadWarned = true;
        }
        return new Promise((resolve, reject) => {
            if (window.location.search.includes('xexeditordemouploaderfail=1')) {
                setTimeout(reject, 5e3, new Error('a demo upload error'));
            }
            else {
                setTimeout(resolve, 5e3, window.URL.createObjectURL(file));
            }
        });
    },
    acceptFile: () => true,
};
export const mergeToolbarConfig = (toolbar) => {
    if (!toolbar) {
        return '';
    }
    if (Array.isArray(toolbar)) {
        return toolbar.join(' ');
    }
    if (typeof toolbar === 'string') {
        return toolbar;
    }
    if (typeof toolbar === 'object') {
        return [toolbar.static, toolbar.popover].filter(Boolean).join(' ');
    }
    return '';
};
//# sourceMappingURL=config.js.map